import { __extends } from "tslib";
import * as React from "react";
import { Component } from "react";
import { paypalLogo } from "./assets/vectors";
var SvgLoader = /** @class */ (function (_super) {
    __extends(SvgLoader, _super);
    function SvgLoader(props) {
        var _this = _super.call(this, props) || this;
        SvgLoader.computeSvgViewport();
        return _this;
    }
    SvgLoader.prototype.componentDidMount = function () {
        SvgLoader.computeSvgViewport();
    };
    SvgLoader.prototype.componentDidUpdate = function () {
        SvgLoader.computeSvgViewport();
    };
    SvgLoader.computeSvgViewport = function () {
        var icons = document.getElementsByClassName('vcp-icon');
        for (var i = 0; i < icons.length; i++) {
            var item = icons.item(i);
            if (item != null) {
                var svg = item.querySelector('svg');
                if (svg) {
                    var bB = svg.getBBox();
                    svg.setAttribute('viewBox', bB.x + ',' + bB.y + ',' + bB.width + ',' + bB.height);
                }
            }
        }
    };
    SvgLoader.prototype.render = function () {
        var _a = this.props, svgString = _a.svgString, className = _a.className, style = _a.style;
        return React.createElement("div", { className: ['vcp-icon', className].join(' '), style: style, dangerouslySetInnerHTML: { __html: svgString } });
    };
    return SvgLoader;
}(Component));
export { SvgLoader };
export var PayPalIcon = function () { return (React.createElement(SvgLoader, { svgString: paypalLogo, style: { height: '50%', overflow: 'hidden' } })); };
//# sourceMappingURL=misc.js.map